import { z } from "zod";

import { requiredString } from "@/common/components/forms/schema";

const loginSchema = z.object({
  username: requiredString("Login.field-is-required"),
  password: requiredString("Login.field-is-required"),
});

type LoginFormValues = z.infer<typeof loginSchema>;

const LOGIN_INITIAL_VALUES: LoginFormValues = {
  username: "",
  password: "",
};

export { loginSchema, LOGIN_INITIAL_VALUES, type LoginFormValues };
